export default {
    documentStatus: {
        complete: 'Completo',
        pending: 'Pendiente',
        error: 'Error',
    },
    containerStatus: {
        inTransit: 'En Tránsito',
        delivered: 'Entregado',
        delayed: 'Retrasado',
        atPort: 'En Puerto',
    },
    riskLevel: {
        low: 'Bajo',
        medium: 'Medio',
        high: 'Alto',
        critical: 'Crítico',
    },
    documentType: {
        billOfLading: 'Conocimiento de Embarque',
        invoice: 'Factura Comercial',
        phytosanitaryCertificate: 'Certificado Fitosanitario',
        movementCertificate: 'Certificado EUR.1',
        packingList: 'Lista de Empaque',
        fumigationCertificate: 'Certificado de Fumigación',
        sadIcm: 'SAD/ICM',
        coo: 'Certificado de Origen',
        unknown: 'Documento Desconocido',
    },
    roles: {
        authority: 'Autoridad',
        freightForwarder: 'Agente de Carga',
        sales: 'Ventas',
        spedizioniere: 'Expedidor',
        dogana: 'Aduana',
        vettoreMarittimo: 'Transportista Marítimo',
        trasportoTerrestre: 'Transporte Terrestre',
        portoImbarco: 'Puerto de Embarque',
        portoSbarco: 'Puerto de Desembarque',
        staffAeroporto: 'Personal del Aeropuerto',
        armatore: 'Armador',
    },
    status: {
        active: 'Activo',
        pending: 'Pendiente',
        rejected: 'Rechazado',
        suspended: 'Suspendido',
        inactive: 'Inactivo',
        accepted: 'Aceptado',
        modified: 'Modificado',
        confirmed: 'Confirmado',
        cancelled: 'Cancelado',
    },
    teamRoles: {
        admin: 'Admin',
        editor: 'Editor',
        viewer: 'Visualizador',
    },
};

